<template>
  <div class="payment-method-selector">
    <label class="payment-method-selector__label">Payment Method</label>
    <b-button-group class="payment-method-selector__group">
      <b-button
        :variant="localMethod === 'cash' ? '' : 'outline-secondary'"
        :class="{ 'payment-method-selector__btn--active': localMethod === 'cash' }"
        class="payment-method-selector__btn"
        @click="selectCash"
        :disabled="disabled"
      >
        <i class="fas fa-money-bill-wave mr-1"></i> Cash
      </b-button>
      <b-button
        :variant="localMethod === 'card' ? '' : 'outline-secondary'"
        :class="{ 'payment-method-selector__btn--active': localMethod === 'card' }"
        class="payment-method-selector__btn"
        @click="selectCard"
        :disabled="disabled"
      >
        <i class="fas fa-credit-card mr-1"></i> Card
      </b-button>
    </b-button-group>
    <b-form-input
      v-if="localMethod === 'card'"
      v-model="localReference"
      placeholder="Transaction reference (optional)"
      class="payment-method-selector__reference mt-2"
      :disabled="disabled"
      @input="emitUpdate"
      size="sm"
    />
  </div>
</template>

<script>
export default {
  name: "paymentMethodSelector",
  props: {
    value: {
      type: Object,
      default: () => ({ method: "cash", reference: "" }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localMethod: this.value.method || "cash",
      localReference: this.value.reference || "",
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.localMethod = newVal.method || "cash";
        this.localReference = newVal.reference || "";
      },
      deep: true,
    },
  },
  methods: {
    selectCash() {
      this.localMethod = "cash";
      this.localReference = "";
      this.emitUpdate();
    },
    selectCard() {
      this.localMethod = "card";
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit("input", {
        method: this.localMethod,
        reference: this.localReference,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/brand";
@import "~@/design/tokens/surfaces";
@import "~@/design/tokens/typography";
@import "~@/design/tokens/spacing";

.payment-method-selector {
  margin-bottom: $space-3;

  &__label {
    font-size: $type-small;
    color: $text-secondary;
    display: block;
    margin-bottom: $space-2;
  }

  &__group {
    width: 100%;
  }

  &__btn {
    flex: 1;
    min-height: 40px;
    font-weight: 600;
    border-color: $border-default;
    color: $text-secondary;
    background: $surface-elevated;

    &--active {
      background: $brand-primary;
      border-color: $brand-primary;
      color: $text-inverse;

      &:hover {
        background: $brand-primary-dark;
        border-color: $brand-primary-dark;
      }
    }

    &:focus-visible {
      outline: 2px solid $brand-primary;
      outline-offset: 2px;
    }
  }

  &__reference {
    background: $surface-input;
    border-color: $border-default;
    color: $text-primary;

    &::placeholder {
      color: $text-muted;
    }
  }
}
</style>
